export interface IEsriMapOptions {
  center?: number[];
  tilt?: number;
  zoom?: number;
  rotation?: number;
  scale?: number;
  animated?: boolean;
}
